import { attr, customElement, FASTElement, observable } from '@microsoft/fast-element';
import { MetricTileStyles as styles } from './metrics-tile.styles';
import { MetricTileTemplate as template } from './metrics-tile.template';
import { DisplayMetrics, IMetric } from "../../../../../types";
import { roundNumber } from '../../../../../utils/formatting';

const name = 'metrics-tile';

@customElement({
  name,
  template,
  styles,
})
export class MetricTile extends FASTElement {
  @attr @observable vppaMetrics: IMetric[];

  connectedCallback(): void {
    super.connectedCallback();
  }


  public formatValues(value: string, fieldName: string) {
    if (!value || isNaN(+value)) {
      return 'N/A';
    }

    let formattedValue = roundNumber(+value).toString();

    switch (fieldName) {
      case 'CFE_3_YEAR_PERCENT':
        formattedValue = formattedValue + '%';
        break;
      case 'EXPECTED_SETTLEMENT_CONTRACT_DATES_USD_PER_MWH':
      case 'BASIS_ASGEN_3_YEAR_USD_PER_MWH':
      case 'CARBON_PRICE_CONTRACT_DATES_USD_PER_MT_CO2E':
        if (+formattedValue < 0) {
          formattedValue = '($' + Math.abs(+formattedValue) + ')';
        } else {
          formattedValue = '$' + formattedValue;
        }
        break;
    }

    return formattedValue;
  }

  public getPosition(rankingValue) {
    switch (rankingValue) {
      case 1:
        return '10%';
        break;
      case 2:
        return '30%';
        break;
      case 3:
        return '50%';
        break;
      case 4:
        return '70%';
        break;
      case 5:
        return '90%';
        break;
    }
  }
}
